import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
const Timelock = props => {
  const $ = _c(6);
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M7 6.5V6C7 4.34315 8.34315 3 10 3V3C11.6569 3 13 4.34315 13 6V6.5" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t1 = <path d="M10 9.5V11.375" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t2 = <path d="M10.9375 12.3125L10 11.375" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t3 = <path d="M4.375 11.375C4.375 8.2684 6.8934 5.75 10 5.75V5.75C13.1066 5.75 15.625 8.2684 15.625 11.375V11.375C15.625 14.4816 13.1066 17 10 17V17C6.8934 17 4.375 14.4816 4.375 11.375V11.375Z" stroke="currentColor" strokeWidth="1.25" strokeLinejoin="round" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== props) {
    t4 = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}{t2}{t3}</svg>;
    $[4] = props;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
export default Timelock;